import { plateformesAPI } from "services/swagger-api"
import { AppInitAsyncActions, AppInitSyncActions } from "./types"

const createAsyncActions = (
  actions: AppInitSyncActions
): AppInitAsyncActions => {
  return {
    initializeApp: async () => {
      try {
        actions.setLoading(true)
        actions.setError(null)

        const response = await plateformesAPI.getCurrentPlateforme()

        if (response) {
          actions.setPlateformeData({
            currentPlateforme: response.currentPlateforme,
            plateformes: response.plateformes,
            theme: response.theme
          })
        }
      } catch (error) {
        actions.setError(
          error instanceof Error
            ? error.message
            : "Une erreur est survenue lors de l'initialisation"
        )
      } finally {
        actions.setLoading(false)
      }
    },

    switchPlateforme: async (plateformeId: string) => {
      try {
        actions.setLoading(true)
        actions.setError(null)

        const response = await plateformesAPI.switchCurrentPlateforme({
          plateformeId: plateformeId
        })

        if (response) {
          actions.switchPlateformeData({
            currentPlateforme: response.currentPlateforme,
            theme: response.theme
          })
        }
      } catch (error) {
        actions.setError(
          error instanceof Error
            ? error.message
            : "Une erreur est survenue lors du changement de plateforme"
        )
      } finally {
        actions.setLoading(false)
      }
    }
  }
}

export default createAsyncActions
